import type { PopoverHeaderProps as ChakraPopoverHeaderProps } from '@chakra-ui/react';
import { PopoverHeader as ChakraPopoverHeader } from '@chakra-ui/react';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';

export type PopoverHeaderProps = OmitChakraProps<ChakraPopoverHeaderProps>;

export const PopoverHeader = withChakraAs<PopoverHeaderProps, 'div'>(
  (props) => {
    return <ChakraPopoverHeader {...props} />;
  },
);
